export enum City {
  TORONTO = 'TORONTO',
  CALGARY = 'CALGARY',
  VANCOUVER = 'VANCOUVER',
  EDMONTON = 'EDMONTON',
  AUSTIN = 'AUSTIN',
  LOS_ANGELES = 'LOS_ANGELES',
  SAN_ANTONIO = 'SAN_ANTONIO',
  SAN_FRANCISCO = 'SAN_FRANCISCO',
  HOUSTON = 'HOUSTON',
  DALLAS = 'DALLAS',
  FORT_WORTH = 'FORT_WORTH',
  // ROUND_ROCK = 'ROUND_ROCK',
  PFLUGERVILLE = 'PFLUGERVILLE',
  JACKSONVILLE = 'JACKSONVILLE',
  MIAMI = 'MIAMI',
  ORLANDO = 'ORLANDO',
  TAMPA = 'TAMPA',
  INDIANAPOLIS = 'INDIANAPOLIS',
  CORPUS_CHRISTI = 'CORPUS_CHRISTI',
}

export type CityString = `${City}`;
